module.exports = __webpack_public_path__ + "static/media/banner_search_btn.05c68ccc.svg";